<ul [ngClass]="db.category.length != 0?'category-bar':''">
  <li class="main-category">
    <a class="d__flex mouse child__1 gap-10" (click)="goto('','All',-1);show_category = false" [class.active-parent]="active == -1">
      <div class="category__img">
        <img src="assets/pos-icons/favourites-02.svg">
      </div>
      <!-- <p class="m-0 category__name">All</p> <span class="badge">{{pos.all_products.length}}</span> -->
      <ion-icon class="" name="chevron-forward-outline"></ion-icon>
    </a>
  </li>
  <li class="main-category" *ngFor="let item of db.category;let i = index">
    <!-- <div> -->
    <a class="d__flex mouse child__1 gap-10" (click)="goto(item,'child-1',i);  show_category?show_category= false:show_category = true" routerDirection="root" [class.active-parent]="item.name == db.childs.child_1 && active != -1" [id]="i+'_scroll'">
      <div class="category__img" *ngIf="item.mobile_image">
        <img [src]="db.product_img(item.mobile_image)">
      </div>
      <p class="m-0 category__name">{{item.category_name}}</p> <span class="badge">{{cat_count(item.name)}}</span>
      <ion-icon (click)="show_category?show_category= false:show_category = true" [name]="(db.childs.child_1 == item.name) && show_category && item.child.length != 0 ?'chevron-down-outline':'chevron-forward-outline'">
      </ion-icon>
    </a>
    <ul *ngIf="db.childs.child_1 == item.name && show_category && !db.ismobile" class="child__2">
      <li *ngFor="let sub of item.child">
        <div class="child-2-li">
          <a (click)="goto(sub,'child-2',i)" [routerLink]="!ismobile?null:'/pos/'+item.name+'/'+sub.name" routerDirection="root" [class.active-child]="sub.name == db.childs.child_2">
            <div class="d__flex gap-10 mouse ">
              <div class="category__img" *ngIf="sub.category_image">
                <!-- <img [src]="db.product_img(sub.category_image)"> -->
              </div>
              <p class="m-0 category__name" [class.active-child-2]="db.childs.child_2 == sub.name">
                {{sub.category_name}}</p> <span class="badge">{{cat_count(sub.name)}}</span>
              <ion-icon (click)="show_hide?show_hide= false:show_hide = true" [name]="(db.childs.child_2 == sub.name)&& show_hide && sub.child.length != 0?'chevron-down-outline':'chevron-forward-outline'">
              </ion-icon>
            </div>
          </a>
        </div>
        <ul *ngIf="show_hide && !ismobile && db.childs.child_2 == sub.name" class="child__3">
          <li class="d__flex p-5" button *ngFor="let sub_child of sub.child">
            <div class="category__img" *ngIf="sub.sub_child">
              <!-- <img [src]="db.product_img(sub.sub_child)"> -->
            </div>
            <a (click)="goto(sub_child,'child-3',i)">
              <p class="m-0 mouse p-5-10 category__name" [ngClass]="(sub_child.name == db.childs.child_3)?'active-child':''"> - {{sub_child.category_name}}</p>
              <span class="badge">{{cat_count(item.name)}}</span>
            </a>
          </li>
        </ul>
      </li>
    </ul>
    <!-- </div> -->
  </li>
</ul>
<ion-segment scrollable *ngIf="sub_cate_list.length > 0" class="tab-segment">
  <ion-segment-button *ngFor="let sub of sub_cate_list" value="{{sub.name}}" (click)="goto(sub,'child-2',active)" [id]="sub.name+'_scroll'" class="menu">
    <span class="tabtext">{{sub.category_name}}</span>
  </ion-segment-button>
</ion-segment>
<!-- <div *ngFor="let item of db.category;let i = index">
  <ul *ngIf="(db.childs.child_1 == item.name && ismobile == true)" class="child__2">
  <li *ngFor="let sub of item.child">
    <div class="child-2-li">
      <a (click)="goto(sub,'child-2',i)" [routerLink]="!ismobile?null:'/pos/'+item.name+'/'+sub.name" routerDirection="root" [class.active-child]="sub.name == db.childs.child_2">
        <div class="d__flex gap-10 mouse ">
          <div class="category__img" *ngIf="sub.category_image">
          </div>
          <p class="m-0 category__name" [class.active-child-2]="db.childs.child_2 == sub.name">
            {{sub.category_name}}</p> <span class="badge">{{cat_count(sub.name)}}</span>
          <ion-icon *ngIf="!ismobile" (click)="show_hide?show_hide= false:show_hide = true" [name]="(db.childs.child_2 == sub.name)&& show_hide && sub.child.length != 0?'chevron-down-outline':'chevron-forward-outline'">
          </ion-icon>
        </div>
      </a>
    </div>
    <ul *ngIf="show_hide && !ismobile && db.childs.child_2 == sub.name" class="child__3">
      <li class="d__flex p-5" button *ngFor="let sub_child of sub.child">
        <div class="category__img" *ngIf="sub.sub_child">
        </div>
        <a (click)="goto(sub_child,'child-3',i)">
          <p class="m-0 mouse p-5-10 category__name" [ngClass]="(sub_child.name == db.childs.child_3)?'active-child':''"> - {{sub_child.category_name}}</p>
          <span class="badge">{{cat_count(item.name)}}</span>
        </a>
      </li>
    </ul>
  </li>
  </ul>
</div> -->
<!-- <li class="main-category" *ngFor="let item of sub_cate_list;let i = index">
  <a (click)="goto(sub,'child-2',i)" [routerLink]="!ismobile?null:'/pos/'+item.name+'/'+sub.name" routerDirection="root" [class.active-child]="sub.name == db.childs.child_2">
    <div class="category__img" *ngIf="item.mobile_image">
      <img [src]="db.product_img(item.mobile_image)">
    </div>
    <p class="m-0 category__name">{{item.category_name}}</p> <span class="badge">{{cat_count(item.name)}}</span>
    <ion-icon (click)="show_category?show_category= false:show_category = true" [name]="(db.childs.child_1 == item.name) && show_category && item.child.length != 0 ?'chevron-down-outline':'chevron-forward-outline'">
    </ion-icon>
  </a>
</li> -->
<!-- <div class="mobile_view" *ngFor="let item of db.category;let i = index">
  <ul *ngIf="db.childs.child_1 == item.name && show_category && db.ismobile" class="child__2">
    <li *ngFor="let sub of item.child">
      <div class="child-2-li">
        <a (click)="goto(sub,'child-2',i)" [routerLink]="!ismobile?null:'/pos/'+item.name+'/'+sub.name"
          routerDirection="root" [class.active-child]="sub.name == db.childs.child_2">
          <div class="d__flex gap-10 mouse just-c">
            <div class="category__img" *ngIf="sub.category_image">
              <!-- <img [src]="db.product_img(sub.category_image)"> 
            </div>
            <p class="m-0 category__name" [class.active-child-2]="db.childs.child_2 == sub.name">
              {{sub.category_name}}</p> 
          </div>
        </a>
      </div>
      <ul *ngIf="show_hide && !ismobile && db.childs.child_2 == sub.name" class="child__3">
        <li class="d__flex p-5" button *ngFor="let sub_child of sub.child">
          <div class="category__img" *ngIf="sub.sub_child">
            <!-- <img [src]="db.product_img(sub.sub_child)"> 
          </div>
          <a (click)="goto(sub_child,'child-3',i)">
            <p class="m-0 mouse p-5-10 category__name"
              [ngClass]="(sub_child.name == db.childs.child_3)?'active-child':''"> - {{sub_child.category_name}}</p>
            <span class="badge">{{cat_count(item.name)}}</span>
          </a>
        </li>
      </ul>
    </li>
  </ul>
</div> -->
